var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBell = function SvgBell(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 34.28A2.67 2.67 0 0 0 20.58 32h-5.26A2.67 2.67 0 0 0 18 34.28ZM32.51 27.83A14.395 14.395 0 0 1 30 24.9a12.628 12.628 0 0 1-1.35-4.81v-4.94c-.003-.6-.057-1.199-.16-1.79a7.438 7.438 0 0 1-2.24-.84c.266.855.401 1.745.4 2.64v4.94a14.24 14.24 0 0 0 1.65 5.85 16.17 16.17 0 0 0 2.44 3H5.13a16.17 16.17 0 0 0 2.44-3 14.24 14.24 0 0 0 1.65-5.85v-4.95A8.8 8.8 0 0 1 18 6.31a8.61 8.61 0 0 1 4.76 1.44A7.489 7.489 0 0 1 22.5 6v-.63a10.58 10.58 0 0 0-3.32-1V3.11a1.335 1.335 0 0 0-2.67 0v1.31a10.81 10.81 0 0 0-9.3 10.73v4.94a12.63 12.63 0 0 1-1.35 4.81 14.397 14.397 0 0 1-2.47 2.93 1 1 0 0 0-.34.75v1.36a1 1 0 0 0 1 1h27.8a1 1 0 0 0 1-1v-1.36a1 1 0 0 0-.34-.75Z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 11a5 5 0 1 0 0-10 5 5 0 0 0 0 10Z",
    fill: "#FFB800"
  })));
};
export default SvgBell;